export const LINK_PANEL_MODAL_LINK_INPUT = 'link-panel-input';
export const LINK_SETTINGS_CHECKBOX_NEW_TAB = 'link-panel-blank-checkbox';
export const LINK_SETTINGS_CHECKBOX_NOREFERRER = 'link-panel-noreferrer-checkbox';
export const LINK_SETTINGS_CHECKBOX_NOFOLLOW = 'link-panel-rel-checkbox';
export const LINK_SETTINGS_CHECKBOX_SPONSORED = 'link-panel-sponsored-checkbox';
